export const BRAND = {
    name: "LuxeNova",
    tagline: "Property | Concierge | Events",
    city: "Warsaw · Kraków, Poland",
    phone: "+48 576 489 912",
    phoneRaw: "+48576489912",
    whatsapp: "+48 576 489 912",
    whatsappRaw: "48576489912",
    email: "hello@luxenova.pl",
    instagram: "luxenova_pl",
    instagramUrl: "https://instagram.com/luxenova_pl",
    facebook: "LuxeNova PL",
    facebookUrl: "https://facebook.com/LuxeNovaPL",
    website: "luxenova.pl",
    websiteUrl: "https://luxenova.pl",
    logo: "https://customer-assets.emergentagent.com/job_8799e2dd-cb3e-4914-a342-7eb1f1fc34f9/artifacts/elav1k8a_WhatsApp%20Image%202026-06-13%20at%203.30.14%20PM.jpeg",
    hero: "https://images.unsplash.com/photo-1779470457779-8dd1d1b649ef?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHxrcmFrb3clMjBza3lsaW5lJTIwd2F3ZWwlMjBjYXN0bGUlMjBzdW5zZXR8ZW58MHx8fHwxNzgyOTAxNjc5fDA&ixlib=rb-4.1.0&q=85",
    images: {
        property: "https://images.pexels.com/photos/8082227/pexels-photo-8082227.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        concierge: "https://images.pexels.com/photos/15774577/pexels-photo-15774577.jpeg",
        events: "https://images.unsplash.com/photo-1769812343285-ec0775437680",
    },
    markets: [
        {
            id: "poland",
            image: "https://images.unsplash.com/photo-1519834584171-14fbb52fdd23?auto=format&fit=crop&w=1400&q=80",
            services: ["sales", "rentals", "cleaning", "maintenance"],
        },
        {
            id: "uae",
            image: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?auto=format&fit=crop&w=1400&q=80",
            services: ["sales", "rentals"],
        },
        {
            id: "georgia",
            image: "https://images.unsplash.com/photo-1571104508999-893933ded431?auto=format&fit=crop&w=1400&q=80",
            services: ["sales", "rentals"],
        },
        {
            id: "cyprus",
            image: "https://images.unsplash.com/photo-1602343168117-bb8ffe3e2e9f?auto=format&fit=crop&w=1400&q=80",
            services: ["sales", "rentals"],
        },
        {
            id: "bali",
            image: "https://images.unsplash.com/photo-1537996194471-e657df975ab4?auto=format&fit=crop&w=1400&q=80",
            services: ["sales", "rentals"],
        },
        {
            id: "maldives",
            image: "https://images.unsplash.com/photo-1514282401047-d79a71a590e8?auto=format&fit=crop&w=1400&q=80",
            services: ["sales", "rentals"],
        },
    ],
};

export const NAV_LINKS = [
    { id: "home", label: "Home", href: "#home" },
    { id: "property", label: "Property", href: "#property" },
    { id: "concierge", label: "Concierge", href: "#concierge" },
    { id: "events", label: "Events", href: "#events" },
    { id: "contact", label: "Contact", href: "#contact" },
];

export const SERVICES = [
    {
        id: "property",
        title: "Property",
        eyebrow: "01 — Real Estate",
        image: BRAND.images.property,
        blurb:
            "From boutique apartments in Kraków's Old Town to signature commercial addresses and investment residences — sourced, managed and maintained with white-glove precision.",
        items: [
            "Residential & Commercial Property Sales",
            "Residential & Commercial Property Rentals",
            "Property Cleaning",
            "Property Maintenance",
        ],
    },
    {
        id: "concierge",
        title: "Concierge",
        eyebrow: "02 — Lifestyle",
        image: BRAND.images.concierge,
        blurb:
            "A single point of contact for the details that matter — from your relocation to Poland to your dinner reservation tonight.",
        items: [
            "Relocation Assistance",
            "Hotel Bookings",
            "Restaurant Reservations",
            "Attraction Bookings",
            "Transportation Arrangements",
        ],
    },
    {
        id: "events",
        title: "Events",
        eyebrow: "03 — Occasions",
        image: BRAND.images.events,
        blurb:
            "Weddings under Wawel's silhouette, corporate galas, and private celebrations — designed, produced and remembered.",
        items: [
            "Corporate Events",
            "Team Building",
            "Gala Dinners",
            "Weddings",
            "Private Parties",
        ],
    },
];

export const PILLARS = [
    { title: "Premium Service", desc: "White-glove attention on every request, every detail." , icon: "Crown" },
    { title: "Trusted Local Expertise", desc: "Deep networks across Kraków and Poland — built over years.", icon: "MapPin" },
    { title: "Personalised Solutions", desc: "Tailored to your family, business or occasion.", icon: "Gem" },
    { title: "Fast Communication", desc: "Direct WhatsApp access to your dedicated advisor.", icon: "MessageCircle" },
    { title: "International Client Focus", desc: "Fluent in the expectations of global clientele.", icon: "Globe2" },
    { title: "Luxury Experience", desc: "A calm, considered, editorial standard — end to end.", icon: "Sparkles" },
];
